// extracted by mini-css-extract-plugin
export default {"outerContent":"_3SaY","left":"_10FI","mentors":"_2o7b","right":"_2uUL","navbarlink":"_1wTM","navbarLabel":"_1XnC"};